import React from 'react';
import numberHelper from '../../util/numberFormatter'
import { Link } from 'react-router-dom'
import CartItemButton from './CartItemButton';

const CartItemList = props => {
  if (!props.data) {
    return (
      <div className={'LoadingPane'}>Loading...</div>
    );
  }

  if (props.data.length === 0) {
    return (
      <div>
        No products...
      </div>
    )
  }

  return (
    <ul className="DataList ProductList">
      {
        props.data.map(item => {
          return (
            <li key={item.key}>
              <strong>{item.name}</strong>
              <em>{item.qty} X {numberHelper.Formatter.toDecimalTrim(item.price)} {item.currency}</em>
              <CartItemButton product={item} type='add' />
              <CartItemButton product={item} type='reduce' />
            </li>
          )
        })
      }
    </ul>
  )
}

export default CartItemList
